import { message } from "antd";
import axios, { AxiosInstance } from "axios";
import endpoints from "../config.production";
export const BASE_URL = endpoints.recordServer;
export const NEW_BASE_URL = endpoints.studioApi;
export const COURSES_URL = endpoints.courseUrl;
export const BROADCAST_URL = endpoints.broadcastUrl;
export const RTMP_SERVER = endpoints.rtmpURl;
export const ADMIN_BASE_URL = endpoints.adminBaseUrl;
export const LOGIN_URL = endpoints.loginUrl;
export const PLAYER_URL = endpoints.playerUrl;
export const PLAYER_URL_NEW = endpoints.playerUrlNew;
export const ADMIN_BASE_URL_2 = endpoints.adminBaseURL2;
export const VIDEO_AUTH= endpoints.videoAuth;
export const API_BASE_URL= endpoints.apiBaseURL

export const getChatUrl = (room: string, token: string) =>
  `https://chat.kgs.live/?room=${room}&token=${token}&medium=studio`;

interface AxiosIns extends AxiosInstance {
  admin: () => AxiosIns;
}
const api = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
  headers: {},
});

api.interceptors.response.use(
  null,
  async (err) => {
    autoErrorHandle(err);
    throw err;
  }
);
//@ts-ignore
// api.admin = function (token: string) {
//   api.defaults.baseURL = ADMIN_BASE_URL;
//   return api;
// };

// export const loginRequest = () => {
//   const token = localStorage.getItem("AUTH_TOKEN");
//   if (token) {
//     api.defaults.headers.common.Authorization = `Bearer ${token}`;
//   }
// };

const autoErrorHandle = (error: any) => {
  if (!error) return;
  if (!error.response) return;
  if (error.response && error.response.status === 401) {
    delete api.defaults.headers.Authorization;
    localStorage.removeItem("AUTH_TOKEN")
    window.location.pathname = "/login";
  }

  if (!error.response.data) return;
  if (error?.response?.data?.data) {
    const errorData = error.response.data?.data;
    Object.keys(errorData).forEach((e) => {
      message.error(errorData[e]);
    });
  }
  if (error.response.data.message) {
    message.error(error.response.data.message);
  }
  return;
};

export default api as AxiosIns;

const studioApi = api.create({
  baseURL: endpoints.studioApi
})

const recordApi = api.create({
  timeout: 10000,
  baseURL: endpoints.recordServer
})

// Retry video processing (HLS or MP4)
export const retryVideo = async (streamKey: string, process: 'hls' | '360p878kbs') => {
  return recordApi.post(`/retry/${streamKey}`, null, {
    params: { process }
  });
};

const adminApi = api.create({
  baseURL: ADMIN_BASE_URL_2
})

const apiBaseURL= api.create({
  baseURL:API_BASE_URL ,
})

export { studioApi, recordApi, adminApi, apiBaseURL }

export function authorizeApi() {
  const token = localStorage.getItem("AUTH_TOKEN");
  if (token) {
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
    studioApi.defaults.headers.common.Authorization = `Bearer ${token}`;
    recordApi.defaults.headers.common.Authorization = `Bearer ${token}`;
    adminApi.defaults.headers.common.Authorization = `Bearer ${token}`;
  }
}
